<template>
  <div class="img_wtapper">
    <el-image class="home_img" src="https://wugecdn.steam.fun/resources/static/m_homepage/m_home.png" fit="fill"></el-image>
  </div>
</template>

<script>
import { getHomepage } from "@/api/homeset";
export default {
  name: "m_index",
  data() {
    return {};
  },
  mounted() {
    console.log("来自手机端");
    // this.getHomepage();
  },
  methods: {
    getHomepage() {
      getHomepage().then((res) => {
        console.log("校区首页");
        console.log(res);
        if (res.homepageData) {
          console.log("有校区信息");
          this.$message.success("有校区信息");
        } else {
          console.log("无校区信息");
          this.$message.warning("无校区信息");
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.img_wtapper {
  width: 100%;
  height: 0;
  padding-bottom: 345%;
  .home_img {
    width: 100%;
    pointer-events: none;
  }
}
</style>


